export default __webpack_public_path__ + "static/achievement_local-d6cb05dfbf55740991f9554a0078b1df.png";